<template>
  <svg
    height="40"
    width="40"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#4051d6"
      width="512"
      height="512"
      rx="110.9"
      ry="110.9"
    />
    <path
      fill="#ffffff"
      d="M145.1,128h51.2v136.5l119.5-51.2v-85.3h51.2v256h-51.2v-119.5l-119.5,51.2v68.3h-51.2V128h0Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
